import ChartAnnotation from "./ChartAnnotation";
import ChartArea from "./ChartArea";
import ChartTitle from "./ChartTitle";
import DownloadArea from "./DownloadArea";
import sectionsJson from "../data/selections/sectionDefinition.json";

function ChartFrame({ selectedState }) {
  const section = sectionsJson[selectedState.partId].sections.find(e => e.id === selectedState.sectionId)
  const element = () => {
    if (section.hasOwnProperty("elements")) {
      return section.elements.find(e => e.id === selectedState.elementId)
    } else {
      return null
    }
  }
  return (
    <div className="border-4 border-solid border-main-blue rounded-md p-7 sm:p-10">
      <ChartTitle
        title={section.fullName}
        element={element()}
      />
      <ChartArea
        selectedState={selectedState}
      />
      <ChartAnnotation
        selectedState={selectedState}
      />
      <DownloadArea
        selectedState={selectedState}
      />
    </div>
  );
}

export default ChartFrame;
